import { AuthResponseErrorType } from '../enum/auth-response-error-type';

export class AuthResponseError extends Error {
  type: AuthResponseErrorType;
  code?: string;
}
